<template>
  <PageBlocks
    :content="page?.blocks"
    :debug="false"
  >
    <!-- template #header>
      <p class="app-gutter">
        Path Page <i>[...path].vue</i> <mark>{{ $route.params.path.join(' - ') }}</mark>
      </p>
    </template-->
  </PageBlocks>
</template>

<script setup>
const route = useRoute();
const { error, page } = await useFetchByPath(route.path);
if (error) {
  throw createError({ statusCode: 404, statusMessage: 'Page Not Found', fatal: true });
}
</script>
